import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#re-bonds-calculator-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'USD';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#re-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const unitPerYear = $container.data('unit-per-year') || '/ рік';
    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const unitMonthsPerYear = $container.data('unit-months-per-year') || 'міс. / рік';
    const unitPercentPerYear = $container.data('unit-percent-per-year') || '% / рік';
    const zeroTaxBadge = $container.data('zero-tax') || '(0% податків)';
    const chartSeriesName = $container.data('chart-series') || 'Річний фінансовий результат';
    const chartGrossLabel = $container.data('chart-gross') || 'Брутто оренда';
    const chartExpensesLabel = $container.data('chart-expenses') || 'Витрати (Ремонт/Податки)';
    const chartNetRentLabel = $container.data('chart-net-rent') || 'Чистий дохід оренди';
    const chartTotalReLabel = $container.data('chart-total-re') || 'Повний дохід (Оренда + Капітал)';
    const chartNetBondLabel = $container.data('chart-net-bond') || 'Чистий дохід ОВДП';

    const $priceRange = $('#re-price-range');
    const $priceDisplay = $('#re-price-display');

    const $renoRange = $('#re-reno-range');
    const $renoDisplay = $('#re-reno-display');

    const $rentRange = $('#re-rent-range');
    const $rentDisplay = $('#re-rent-display');

    const $vacancyRange = $('#re-vacancy-range');
    const $vacancyDisplay = $('#re-vacancy-display');

    const $maintRange = $('#re-maint-range');
    const $maintDisplay = $('#re-maint-display');

    const $taxRange = $('#re-tax-range');
    const $taxDisplay = $('#re-tax-display');

    const $apprecRange = $('#re-appreciation-range');
    const $apprecDisplay = $('#re-appreciation-display');

    const $bondRange = $('#re-bond-range');
    const $bondDisplay = $('#re-bond-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString('uk-UA') + ' ' + symbol;
    }

    function parseNum(val, defaultVal) {
        const num = parseFloat(val);
        return isNaN(num) ? defaultVal : num;
    }

    function calculate() {
        const price = parseNum($priceRange.val(), 60000);
        const reno = parseNum($renoRange.val(), 15000);
        const rent = parseNum($rentRange.val(), 500);
        const vacancy = parseNum($vacancyRange.val(), 1.0);
        const maintRate = parseNum($maintRange.val(), 1.0) / 100;
        const taxRate = parseNum($taxRange.val(), 5.0) / 100;
        const apprecRate = parseNum($apprecRange.val(), 3.0) / 100;
        const bondRate = parseNum($bondRange.val(), 4.8) / 100;

        $priceDisplay.text(formatMoney(price));
        $renoDisplay.text(formatMoney(reno));
        $rentDisplay.text(formatMoney(rent) + ' ' + unitPerMonth);
        $vacancyDisplay.text(vacancy.toFixed(1) + ' ' + unitMonthsPerYear);
        $maintDisplay.text((maintRate * 100).toFixed(1) + unitPercentPerYear);
        $taxDisplay.text((taxRate * 100).toFixed(1) + '%');

        const apprecPercent = (apprecRate * 100).toFixed(1);
        const apprecPrefix = apprecRate > 0 ? '+' : '';
        $apprecDisplay.text(apprecPrefix + apprecPercent + unitPercentPerYear);
        if (apprecRate > 0) {
            $apprecDisplay.removeClass('text-danger text-body').addClass('text-success');
        } else if (apprecRate < 0) {
            $apprecDisplay.removeClass('text-success text-body').addClass('text-danger');
        } else {
            $apprecDisplay.removeClass('text-success text-danger').addClass('text-body');
        }

        $bondDisplay.text((bondRate * 100).toFixed(1) + '% ' + zeroTaxBadge);

        const totalCapital = price + reno;
        const occupiedMonths = Math.max(0, 12 - vacancy);
        const grossAnnualRent = rent * occupiedMonths;

        const annualMaintenance = price * maintRate;
        const annualTax = grossAnnualRent * taxRate;
        const netRentalCash = Math.round(grossAnnualRent - annualMaintenance - annualTax);

        const netRentalYield = totalCapital > 0 ? ((netRentalCash / totalCapital) * 100).toFixed(1) : '0.0';

        // Property Value Growth/Decline
        const annualAppreciationCash = Math.round(price * apprecRate);
        const totalRealEstateGain = netRentalCash + annualAppreciationCash;
        const totalRealEstateROI = totalCapital > 0 ? ((totalRealEstateGain / totalCapital) * 100).toFixed(1) : '0.0';

        // Bonds
        const bondAnnualCash = Math.round(totalCapital * bondRate);
        const bondYield = (bondRate * 100).toFixed(1);

        // Difference: Compare total real estate financial result vs bonds
        const diffAnnual = totalRealEstateGain - bondAnnualCash;
        const diffPrefix = diffAnnual >= 0 ? '+' : '';

        $('#re-kpi-net-yield').text(netRentalYield + '%');
        $('#re-kpi-total-roi').text(totalRealEstateROI + '%');
        $('#re-kpi-bond-yield').text(bondYield + '%');
        $('#re-kpi-diff').text(diffPrefix + formatMoney(diffAnnual) + ' ' + unitPerYear);
        if (diffAnnual >= 0) {
            $('#re-kpi-diff').removeClass('text-danger').addClass('text-success');
        } else {
            $('#re-kpi-diff').removeClass('text-success').addClass('text-danger');
        }

        renderChart(grossAnnualRent, annualMaintenance + annualTax, netRentalCash, totalRealEstateGain, bondAnnualCash);
    }

    function renderChart(grossRent, deductions, netRent, totalReGain, bondCash) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [{
                name: chartSeriesName,
                data: [
                    Math.round(grossRent),
                    Math.round(deductions),
                    Math.round(netRent),
                    Math.round(totalReGain),
                    Math.round(bondCash)
                ]
            }],
            chart: {
                type: 'bar',
                height: 250,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#556ee6', '#f46a6a', '#f1b44c', '#34c38f', '#50a5f1'],
            plotOptions: {
                bar: {
                    distributed: true,
                    borderRadius: 4,
                    columnWidth: '55%'
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return formatMoney(val);
                },
                style: {
                    fontSize: '11px',
                    colors: [isDark ? '#eff2f7' : '#343a40']
                }
            },
            xaxis: {
                categories: [
                    chartGrossLabel,
                    chartExpensesLabel,
                    chartNetRentLabel,
                    chartTotalReLabel,
                    chartNetBondLabel
                ],
                labels: {
                    style: {
                        colors: isDark ? '#a6b0cf' : '#74788d',
                        fontSize: '11px'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (Math.abs(val) >= 1000) return Math.round(val / 1000) + 'K ' + symbol;
                        return Math.round(val) + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            legend: { show: false },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#re-vs-bonds-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Input listeners
    $priceRange.on('input', calculate);
    $renoRange.on('input', calculate);
    $rentRange.on('input', calculate);
    $vacancyRange.on('input', calculate);
    $maintRange.on('input', calculate);
    $taxRange.on('input', calculate);
    $apprecRange.on('input', calculate);
    $bondRange.on('input', calculate);

    // Currency Switcher
    function setReCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#re-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.re-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.re-more-currencies-btn').addClass('active');
            $('#re-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#re-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.re-more-currencies-btn').removeClass('active');
            $('.re-currency-dropdown-item').removeClass('active');
            $('#re-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const price = parseNum($(btn).data('price'), 60000);
        const reno = parseNum($(btn).data('renovation'), 15000);
        const rent = parseNum($(btn).data('rent'), 500);
        const bond = parseNum($(btn).data('bond'), 4.8);
        const apprec = parseNum($(btn).data('appreciation'), 3.0);

        $priceRange.val(price);
        $renoRange.val(reno);
        $rentRange.val(rent);
        $bondRange.val(bond);
        $apprecRange.val(apprec);

        if (currency === 'UAH' || currency === 'CZK') {
            $priceRange.attr({ min: 500000, max: 10000000, step: 50000 });
            $renoRange.attr({ min: 0, max: 3000000, step: 25000 });
            $rentRange.attr({ min: 5000, max: 150000, step: 500 });
        } else if (currency === 'PLN') {
            $priceRange.attr({ min: 100000, max: 2000000, step: 15000 });
            $renoRange.attr({ min: 0, max: 500000, step: 5000 });
            $rentRange.attr({ min: 1000, max: 25000, step: 100 });
        } else {
            $priceRange.attr({ min: 15000, max: 500000, step: 2500 });
            $renoRange.attr({ min: 0, max: 150000, step: 1000 });
            $rentRange.attr({ min: 100, max: 10000, step: 50 });
        }

        calculate();
    }

    $('#re-currency-tabs > button[data-currency-code]').on('click', function () {
        setReCurrency(this, false);
    });

    $(document).on('click', '.re-currency-dropdown-item', function (e) {
        e.preventDefault();
        setReCurrency(this, true);
    });

    calculate();
});

